<div
    *ngIf="loading; else content"
    class="h-100 w-100 d-flex align-items-center justify-content-center"
>
    <app-loader-default></app-loader-default>
</div>

<ng-template #content>
    <div
        *ngIf="authorized; else notAuthorized"
        class="h-100 w-100 position-relative row p-0 m-0 mt-2"
    >
        <div
            class="h-100 w-100 position-relative row p-0 m-0"
            *ngIf="!emptyState; else emptyStateTemplate"
        >
            <div class="col-12 p-0 m-0 flex-column center">
                <div class="text">
                    <div class="labelDisplay ref-text">
                        <div [ngSwitch]="calendarSelect">
                            <div *ngSwitchCase="'day'">
                                <span>
                                    {{
                                        'detailPageCounting.label.groups.day'
                                            | translate
                                    }}
                                    : {{ averageDisplay.current }}
                                </span>
                            </div>
                            <div *ngSwitchCase="'week'">
                                <span>
                                    {{
                                        'detailPageCounting.label.groups.week'
                                            | translate
                                    }}
                                    : {{ averageDisplay.current }}
                                </span>
                            </div>
                            <div *ngSwitchCase="'month'">
                                <span>
                                    {{
                                        'detailPageCounting.label.groups.month'
                                            | translate
                                    }}
                                    {{ averageDisplay.current }}</span
                                >
                            </div>
                            <div *ngSwitchCase="'year'">
                                <span>
                                    {{
                                        'detailPageCounting.label.groups.year'
                                            | translate
                                    }}
                                    {{ averageDisplay.current }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text">
                    <div class="labelDisplay comp-text">
                        vs: {{ averageDisplay.versus }}
                    </div>
                </div>
            </div>

            <div
                class="col-12 h-100 overflow-scroll"
                style="height: 73% !important"
            >
                <div
                    class="row"
                    *ngFor="let label of getMaxArray(); let i = index"
                    style="height: 3em"
                >
                    <div class="col-2 center p-0 m-0 h-100">
                        <div class="text center h-100 flex-column">
                            <div
                                [ngSwitch]="calendarSelect"
                                class="text center h-100 flex-column"
                            >
                                <div *ngSwitchCase="'day'" class="labelXAxisVs">
                                    {{ _labels[i] }}
                                </div>
                                <div *ngSwitchCase="'week'">
                                    <div class="labelXAxis">
                                        {{ _labels[i] }}
                                    </div>
                                    <div class="labelXAxisVs">
                                        {{ _labelsVs[i] }}
                                    </div>
                                </div>
                                <div *ngSwitchCase="'month'">
                                    <div class="labelXAxis">
                                        {{ _labels[i] }}
                                    </div>
                                    <div class="labelXAxisVs">
                                        {{ _labelsVs[i] }}
                                    </div>
                                </div>
                                <div *ngSwitchCase="'year'">
                                    <div class="labelXAxis">
                                        {{ _labels[i] }}
                                    </div>
                                    <div class="labelXAxisVs">
                                        {{ _labelsVs[i] }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="col-6 center p-0 m-0 _first_chart_container_ h-100"
                    >
                        <div class="_second_chart_container_ w-100 h-100">
                            <canvas
                                [id]="'groups_chart' + i"
                                class="_chart_data_compare_x_axis_counting h-100 w-100"
                            ></canvas>
                        </div>
                    </div>
                    <div
                        class="col-4 d-flex flex-row justify-content-around py-1"
                    >
                        <div class="row">
                            <div
                                class="col-5 d-flex flex-column justify-content-around align-items-center py-1"
                            >
                                <div
                                    class="ref-text d-flex align-items-center"
                                    style="height: 0px"
                                >
                                    {{ _value[i] | roundedWithRules : 1 }}
                                </div>
                            </div>

                            <div
                                class="col-5 border-start d-flex flex-column justify-content-around align-items-center py-1"
                            >
                                <div
                                    class="comp-text d-flex align-items-center"
                                    style="height: 0px"
                                >
                                    {{ _valueVs[i] | roundedWithRules : 1 }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #emptyStateTemplate>
            <div class="col-12">
                <div
                    class="center indic bg-greyOpacity radius-secondary p-3 m-3"
                >
                    {{ 'closedData' | translate }}
                </div>
            </div>
        </ng-template>
    </div>

    <ng-template #notAuthorized>
        <div class="indic bg-greyOpacity radius-secondary p-3 m-3">
            <div class="small" [innerHTML]="'noGroupsData' | translate"></div>
        </div>
    </ng-template>
</ng-template>
